import PaymentLinkResultPage from "../components/payment-link/PaymentLinkResultPage";

export default PaymentLinkResultPage;
